import React from 'react'
import moment from 'moment'
import OperacionesCpe from '../OperacionesCpe'
import CamionPenalizadoEnPlaya from '../components/CamionPenalizadoEnPlaya'
import DetallesCamionesEnPlaya from '../containers/DetallesCamionesEnPlaya'
import TableValueAction from '../../../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../busquedaCpa/InfoCpa'

export function getColumnasCamionesEnPlaya (rolAutorizado = false) {
  return ([
    {
      name: 'detalle',
      label: ' ',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: detalle => {
          return detalle.penalizado
            ? <CamionPenalizadoEnPlaya
              penalizado={detalle.penalizado}
              patente={detalle.camion}
            />
            : null
        }
      }
    },
    {
      name: 'fechaVencimientoPenalizacion',
      label: 'Vencimiento penalizacion',
      options: {
        filter: false,
        sort: true,
        display: false,
        customBodyRender: (f) => {
          return (f ? moment(f).format('DD-MM-YY HH:mm') : <></>)
        }
      }
    },
    {
      name: 'fechaDeIngreso',
      label: 'Fecha Ingreso',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => fecha ? <>{moment(fecha).format('DD/MM/YY HH:mm')}</> : null
      }
    },
    {
      name: 'numero',
      label: 'CTG',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (cpa) => {
          return <>
            {cpa
              ? <TableValueAction
                value={cpa}
                title=' '
                content={<InfoCpa cpa={cpa} />} />
              : null
            }
          </>
        }
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: []
      }
    },
    {
      name: 'cerealVariedad',
      label: 'Cereal Variedad',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        filterList: [],
        customBodyRender: (v) => {
          return ((v.trim() === 'UNDEF') ? ' - ' : v)
        }
      }
    },
    {
      name: 'camion',
      label: 'Camión',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'titularDeCupo',
      label: 'Titular de Cupo',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'corredorVendedor',
      label: 'Corredor',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'vendedor',
      label: 'Entregador',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterType: 'multiselect'
      }
    },
    {
      name: 'turnoDeSalida',
      label: 'Turno Salida',
      options: {
        filter: false,
        sort: true
      }
    },
    {
      name: 'estadoCtg',
      label: 'Estado CTG',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        customBodyRender: (value) => value !== 'V'
          ? <><strong style={{ color: '#8e1a05de' }}> Sin Confirmar </strong> </>
          : <><strong style={{ color: '#023a1ade' }}> Confirmado </strong> </>
      }
    },
    {
      name: 'estadoIngreso',
      label: 'Estado ingreso',
      options: {
        filter: true,
        sort: false,
        filterList: [],
        filterType: 'checkbox',
        display: false
      }
    },
    {
      name: 'codigoCupo',
      label: 'Código Cupo',
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: 'numero',
      label: ' ',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: value => {
          return ((rolAutorizado) ? <OperacionesCpe numero={value} /> : <></>)
        }
      }
    },
    {
      name: 'autodescargable',
      label: 'Autodescargable',
      options: {
        filter: true,
        sort: true,
        display: false,
        filterList: [],
        customBodyRender: autodescargable => {
          return (autodescargable) ? 'Si' : '  '
        }
      }
    },
    {
      name: 'detalle',
      label: ' ',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: detalle => {
          return <DetallesCamionesEnPlaya detalle={detalle} />
        }
      }
    }
  ])
}

export const COLUMNS_CAMIONES_EN_PLAYA_TO_PRINT = [
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal Variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeIngreso',
    label: 'Fecha de Ingreso',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de Cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'razonSocialTitular',
    label: 'Titular CPE',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor Vta. Sec.',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camión',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'pesoNeto',
    label: 'Peso Neto [Kgs]',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'turnoDeSalida',
    label: 'Turno Salida',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'estadoCtg',
    label: 'Estado CTG',
    width: 60,
    mantenerCase: true
  }
]
